import { Classes, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import CX from 'classnames'
import * as React from 'react'
import { UprightStyle } from '../../types'
import { ITextSeparatorDotProps } from './types'

const styles: UprightStyle = {
  spacer: { margin: '0 5px' }
}

export const TextSeparatorDot: React.FC<ITextSeparatorDotProps> = props => {
  return (
    <span style={styles.spacer} className={CX({ [Classes.TEXT_MUTED]: props.muted })}>
      <Icon icon={IconNames.DOT} color={props.color} />
    </span>
  )
}
